module.exports = __webpack_public_path__ + "img/qualification_2.169d4d8c.png";